import React from 'react'
import { AlertModalProps } from '@musinsa/mwms-ds'
import { ConfirmModalList } from '@/components/content/Alert'
import { Utils } from '@/utils/Utils'
import ModalAction from '@/utils/modal/ModalAction'

const CONFIRM_ID = 'moms-confirm'

type MConfirmActionType = Omit<AlertModalProps, 'open'>

class MConfirmAction extends ModalAction<MConfirmActionType> {
  destroy = (id: string) => {
    const deletedIdx = this.list.findIndex((confirm) => confirm.id === id)
    this.list.splice(deletedIdx, 1)

    if (this.root && this.list.length) {
      this.root.render(<ConfirmModalList list={this.list} destroy={this.destroy} />)
    }
  }

  show = (content: React.ReactNode, props: Omit<MConfirmActionType, 'id' | 'content'>) => {
    this.list.push({ ...props, content, id: Utils.uuid() })

    if (this.root) {
      this.root.render(<ConfirmModalList list={this.list} destroy={this.destroy} />)
    }
  }
}

const MConfirm = new MConfirmAction(CONFIRM_ID)
export default MConfirm
